import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import Divider from '@mui/material/Divider'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'

import EventInfoBox from '../../events/components/EventInfoBox'
import { Card } from '../../dashboard/Dashboard'
import { Events } from '../../../types'
import { formatDateTime, getOption, useEventsTypeOptions } from '../../../utils'

interface Props {
  events: Events[]
  onClick: (id: number) => void
  href: (id: number) => string
}

export function EventsList({ events, onClick, href }: Props) {
  const { t } = useTranslation('abstracts')
  const { eventId } = useParams()

  const eventsTypeOptions = useEventsTypeOptions(t)

  return (
    <Stack
      flexGrow={{ xs: 'auto', md: '0.45 0' }}
      flexBasis="content"
      minWidth={400}
      minHeight={{ xs: 'auto', sm: 'auto', md: 340 }}
      sx={theme => ({
        backgroundColor: theme.colors.greyBackground,
        overflowY: { xs: 'hidden', md: 'auto' },
      })}
      height="100%"
    >
      <Stack
        gap="1rem"
        padding="1rem"
        direction={{ xs: 'row', md: 'column' }}
        sx={{ overflowX: { xs: 'auto', md: 'hidden' } }}
      >
        {events?.map(event => {
          const type = getOption(eventsTypeOptions, undefined, event.type)
          return (
            <Card
              key={event.id}
              color={type?.color}
              onClick={e => {
                e.preventDefault()
                onClick(event.id)
              }}
              href={href(event.id)}
              sx={{
                minWidth: { xs: '300px', sm: '350px' },
                minHeight: { xs: 'inherit', md: '240px', lg: '270px' },
                overflowY: { xs: 'scroll', md: 'hidden' },
              }}
              active={event.id === Number(eventId)}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                width="-webkit-fill-available"
              >
                <h4>{event.name}</h4>
                <Chip
                  color="primary"
                  sx={{
                    backgroundColor: type?.color,
                  }}
                  label={type?.label}
                />
              </Stack>
              <Stack direction="column" sx={{ display: { xs: 'none', md: 'block' } }}>
                <EventInfoBox
                  start={event.start}
                  end={event.end}
                  location={event.location}
                  direction="column"
                />
                <Divider />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                width="-webkit-fill-available"
                gap="0.5rem"
              >
                <Stack direction="row" alignItems="center" gap="0.5rem">
                  <Typography sx={{ textAlign: 'start', display: { xs: 'block', md: 'none' } }}>
                    {formatDateTime(event.start)} - {formatDateTime(event.end)} :
                  </Typography>
                </Stack>
              </Stack>
            </Card>
          )
        })}
      </Stack>
    </Stack>
  )
}
